<template>
    <div style="padding: 14px; padding-bottom: 0px; position: relative;">
        <md-dialog-content>
            <button @click="closeDialogModel" 
                    style="background: none; border: none; position: absolute; top: 0px; right: 0px; cursor: pointer;">
                <md-icon>close</md-icon>
            </button>
            <p>Create Your Project</p>
            <md-input-container>
                <label for="project-name">Project Name</label>
                <md-input required v-model="project.title"></md-input>
                <span class="md-error" v-if="titleError">{{ titleError }}</span>
            </md-input-container>
            <md-input-container>
                <label for="file">File</label>
                <md-file required ref="fileproject" class="file-input" @selected="onFileChange" accept="application/pdf"></md-file>
            </md-input-container>
            <md-input-container>
                <label for="your-role">Your role</label>
                <md-input required v-model="project.ownerRole"></md-input>
                <span class="md-error" v-if="roleError">{{ roleError }}</span>
            </md-input-container>
        </md-dialog-content>
    </div>      
</template>
    
<script>
const Create = {
    name: 'create',
    props: ['project'],
    data() {
        return {
            titleError: '',
            roleError: ''
        };
    },
    watch: {
        // Watcher for project properties
        'project.title': function() {
            this.checkInputs();
        },
        'project.ownerRole': function() {
            this.checkInputs();
        },
        'project.fileObject': function(newVal) {
            this.checkInputs();
            if (newVal === null && this.$refs.fileproject) {
                this.$refs.fileproject.value = null;
            }
        }
    },
    mounted() {
        this.checkInputs(); // Check inputs when the component is mounted
    },
    methods: {
        checkInputs: function() {
            this.validateTitle();
            this.validateRole();
            const allFilled = this.project.title && this.project.fileObject && this.project.ownerRole && !this.titleError && !this.roleError;
            this.$emit('update:isAllInputsFilled', allFilled);
        },
        validateTitle: function() {
            if (!this.project.title) {
                this.titleError = 'Project name is required';
            } else if (this.project.title.trim().length === 0) {
                this.titleError = 'Project name cannot be empty';
            } else {
                this.titleError = '';
            }
        },
        validateRole: function() {
            if (!this.project.ownerRole) {
                this.roleError = 'Role is required';
            } else if (this.project.ownerRole.trim().length === 0) {
                this.roleError = 'Role cannot be empty';
            } else {
                this.roleError = '';
            }
        },
        onFileChange: function(fileList) {
            if (fileList.length > 0) {
                this.project.fileObject = fileList[0];
            }
            this.checkInputs();
        },
        closeDialogModel: function() {
            this.project.fileObject = null;
            if (this.$refs.fileproject) {
                this.$refs.fileproject.value = null;
            }
            this.$emit('close-dialog');
        }
    }
};
export default Create;
</script>

<style>
.md-error {
    color: #ff1744;
    font-size: 12px;
    margin-top: 3px;
}
</style>


// WEBPACK FOOTER //
// create.vue?bcdd07ce